import { usePrefersReducedMotion } from "@chakra-ui/react";
import { motion } from "framer-motion";
import type { ComponentProps } from "react";

type AnimatedSvgProps = ComponentProps<typeof motion.svg>;

export const AnimatedSvg = ({ children, className, ...props }: AnimatedSvgProps) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <motion.svg
      className={["scroll-graphic", className].filter(Boolean).join(" ")}
      initial={prefersReducedMotion ? false : "hidden"}
      whileInView={prefersReducedMotion ? undefined : "visible"}
      viewport={{ once: true, amount: 0.55, margin: "0px 0px -8% 0px" }}
      {...props}
    >
      {children}
    </motion.svg>
  );
};
